// app/global-error.tsx
// Catches errors that happen above/outside any [locale]/error.tsx boundary
// (e.g. in [locale]/layout.tsx itself). Without this file, such errors fall
// through to Next.js's hardcoded "Application error: a client-side exception
// has occurred" page instead of a page we control.
'use client'

import { useClientErrorReporter } from '@/lib/useClientErrorReporter'

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    const recovering = useClientErrorReporter(error, '[global-error] ')

    const handleReload = () => {
        window.location.href = '/'
    }

    if (recovering) {
        return (
            <html>
                <body />
            </html>
        )
    }

    return (
        <html>
            <body>
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '16px',
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                }}>
                    <div style={{ textAlign: 'center', maxWidth: 420 }}>
                        <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12, color: '#1f2937' }}>
                            Что-то пошло не так
                        </h2>
                        <p style={{ fontSize: 15, color: '#6b7280', marginBottom: 8 }}>
                            Произошла непредвиденная ошибка. Попробуйте обновить страницу.
                        </p>
                        <p style={{ fontSize: 14, color: '#9ca3af', marginBottom: 24 }}>
                            Nomaʼlum xatolik yuz berdi. Sahifani yangilab koʻring.
                        </p>
                        <button
                            onClick={handleReload}
                            style={{
                                background: '#ff7900',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 10,
                                padding: '12px 24px',
                                fontSize: 15,
                                fontWeight: 500,
                                cursor: 'pointer',
                            }}
                        >
                            На главную / Bosh sahifaga
                        </button>
                    </div>
                </div>
            </body>
        </html>
    )
}
